// extracted by mini-css-extract-plugin
export default {"tableWrapper":"styles_tableWrapper__2e4Jb","table":"styles_table__VTsv8","textCell":"styles_textCell__epBhP","clickableRow":"styles_clickableRow__i0Cgb"};